import React from 'react';
import {Bar} from 'react-chartjs-2'







export default class  extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
        
        }
    }



     data = {
        labels: this.props.varianteRaspuns,
        datasets: 
        //   {
        //     label: this.props.intrebare,
        //     backgroundColor: 'rgba(255,99,132,0.2)',
        //     borderColor: 'rgba(255,99,132,1)',
        //     borderWidth: 1,
        //     hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        //     hoverBorderColor: 'rgba(255,99,132,1)',
        //     data: this.props.procenteRaspunsuri,

        //   },

        this.props.dataGraph

       
         
        
      };

    

     componentDidMount(){
    }
     render() { 
       return (
          <div >
              <h4 style={{textAlign:'left', marginLeft:20}} className='pm-title'>{this.props.titlu}</h4>
        <Bar
          data={this.data}
         width={100}
          height={50}
          options={{
              
            maintainAspectRatio: true
          }}
        />
         </div>
        );
       }
}